import { jsx as _jsx } from "react/jsx-runtime";
import { Stack } from "__barrel_optimize__?names=Stack!=!@mui/material";
import { appStyled } from "../utilityFunctions";
const ResponsiveBox = appStyled(Stack)((param)=>{
    let { theme, flex, paddingLeft, paddingRight, paddingBottom, isMobileWithFooter, height } = param;
    return {
        flexDirection: "column",
        paddingLeft: paddingLeft || "100px",
        paddingRight: paddingRight || "100px",
        paddingBottom: paddingBottom || "30px",
        height: height || "calc(100vh - 72px)",
        flex: flex || "auto",
        [theme.breakpoints.down("lg")]: {
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingBottom: isMobileWithFooter ? "35px" : "20px",
            height: height || (isMobileWithFooter ? "calc(100vh - 102px)" : "calc(100vh - 52px)")
        }
    };
});
const Wrapper = (param)=>{
    let { children, flex, paddingLeft, paddingRight, paddingBottom, isMobileWithFooter, height } = param;
    return /*#__PURE__*/ _jsx(ResponsiveBox, {
        flex: flex,
        paddingLeft: paddingLeft,
        paddingRight: paddingRight,
        paddingBottom: paddingBottom,
        isMobileWithFooter: isMobileWithFooter,
        height: height,
        children: children
    });
};
export default Wrapper;
